module.exports = __webpack_public_path__ + "img/cylinder.afa14d31.png";